import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=76124440"
import script from "./FormSection.ts?vue&type=script&lang=ts&external"
export * from "./FormSection.ts?vue&type=script&lang=ts&external"
import style0 from "../../styles/FormSection/formSection.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports